module.exports = __webpack_public_path__ + "static/media/lunbo1.d7324143.png";